module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-2efbb4c3f73e7e1317ea4dd59ca69623.webp";